export default __webpack_public_path__ + "d00fe2c8fc698f9913c027167e9eda44.png";